<template lang="html">
  <div class="container-fluid __windowHeight_">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
     <div class="col-sm p-0">
       <div class="_verification_page">
         <div class="col-sm p-0">
           <div class="row m-0 afterverify_page align-items-center justify-content-center">
             <div class="text-center">
               <img src="@/assets/image/icon/verified.svg" alt="">
               <h5>
                 Please Upload All Document Required (SIUP, KTP, NPWP, NIB) in the Settings Menu.
                 We Will Contact You within 24 (Working) Hours to Confirm Your Application.
               </h5>
             </div>
           </div>
         </div>
       </div>
     </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
export default {
  components: {
    Sidebar
  }
}
</script>



// WEBPACK FOOTER //
// src/view/verifyAcc/index.vue